export default {
    getData(state) {
        return state.data;
    },
    getBranches(state) {
        return state.branches;
    },
    getDrivers(state) {
        return state.drivers;
    },
    getAddresses(state) {
        return state.addresses;
    },
    getTotal(state) {
        return state.total;
    },

    getStatues(state) {
        return state.statues;
    },

    getCancelReasons(state) {
        return state.cancelReasons;
    },


    getDetail(state) {
        return state.detail;
    },

    getProducts(state) {
        return state.products;
    },
    getAdmins(state) {
        return state.admins;
    },

    getOrderTypes(state) {
        return state.orderTypes;
    },

    getVehicleTypes(state) {
        return state.vehicleTypes;
    },

    getProductDetail(state) {
        return state.productDetail;
    },


    getCart(state) {
        return state.cart;
    },
    getDeleteOrders(state) {
        return state.deletedOrders;
    },


};
